var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.suggestion.title !== undefined)?_c('button',{domProps:{"innerHTML":_vm._s(_vm.decodeHTMLEntities(_vm.suggestion.title))},on:{"click":function($event){return _vm.searchSuggestion(_vm.suggestion)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }